import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from '@material-ui/core';
import { Button } from '@payactive/app-common';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  backDrop: {
    backdropFilter: 'blur(30px)',
    backgroundColor: 'rgba(0,0,30,0.4)',
  },
  button: {
    backgroundColor: theme.palette.error.main,
  },
}));

interface Props {
  extra?: string;
  open: boolean;
  product: any;
  onClose: () => void;
  onDelete: (id: string, toggle: boolean) => void;
}

export default function DeleteProductDialog({ open, extra, product, onClose, onDelete }: Props): ReactElement {
  const { t } = useTranslation('payments');
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return false;
        }
        onClose();
      }}
      BackdropProps={{
        classes: {
          root: classes.backDrop,
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">{t('delete product')}</DialogTitle>
      <DialogContent dividers>
        <DialogContentText id="alert-dialog-description" style={{ color: 'black' }}>
          {extra === 'withPaylinks' ? t('text with paylink', { name: product.name }) : t('text without paylink')}
        </DialogContentText>
        {/*         {extra === 'withPaylinks' && (
          <FormControlLabel
            control={
              <Switch
                onChange={(e) =>
                  e.target.checked ? setIsToggleChecked(true) : setIsToggleChecked(false)
                }
                name="delete all paylinks"
              />
            }
            label={t('delete all paylinks')}
          />
        )}
 */}{' '}
      </DialogContent>
      <DialogActions>
        <Button variant="text" name="cancel" label={t('global:cancel')} onClick={onClose} />
        <Button className={classes.button} name="delete" variant="contained" label={t('delete product')} onClick={() => onDelete(product.id, true)} />
      </DialogActions>
    </Dialog>
  );
}
